/**
 * ? @description : Students Training Component
 */

// Dependencies
import React, { Fragment, useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Box, Chip, CircularProgress, IconButton } from "@mui/material";
import Axios from "../../../../axios/Axios";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/features/appSlice";

// Modals
import StudentDetails from "./modals/StudentDetails";
import { LibraryBooks } from "@mui/icons-material";
import {  useNavigate, } from "react-router-dom";
import axios from "axios";


function StudentTraining() {
  // * State Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const history = useHistory();
  const [studentsData, setStudentsData] = useState([]);
  const [studentModal, setStudentModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [isDataFetchError, setIsDataFetchError] = useState(false);


  // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPage, setRowsPage] = useState(rowsPerPage);

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };
  const [pageRange, setPageRange] = useState(0);
  const [updatePageRange, setUpdatePageRange] = useState(pageRange);

  const handlePageChange = (currentPage) => {
    setPageRange(currentPage);
  }
  // console.log(pageRange);
  //   console.log(rowsPerPage);
  // * Fetching Data
  useEffect(() => {
    const controller = axios.CancelToken.source();

    (async () => {
      try {

        const storedRowsPerPage = sessionStorage.getItem('selectedRowsPerPage', rowsPerPage)
        const rowsPerPageToUse = storedRowsPerPage ? parseInt(storedRowsPerPage) : rowsPerPage;

        const storedPage = sessionStorage.getItem('selectedPage', pageRange)
        const rowsPageToUse = storedPage ? parseInt(storedPage) : pageRange;
        const response = await Axios("GET", "/student/view/trainingview", true, null, { cancelToken: controller.token });

        // console.log(response);
        if (response.status === 200) {
          response.data.length !== 0 ? setStudentsData(response.data) : setIsDataFetchError(true)
        }
        setRowsPage(rowsPerPageToUse)
        setUpdatePageRange(rowsPageToUse)

        sessionStorage.removeItem('selectedRowsPerPage');
        sessionStorage.removeItem('selectedPage');

      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log(error);
          setIsDataFetchError(true);
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve student training data",
              severity: "error",
            })
          );
        }
      }
    })()
  
    return () => {
      controller.cancel();
  }
  }, [dispatch, rowsPerPage, pageRange]);

  const handleNavigation = (studentId) => {
    // const currentPath = window.location.pathname;

    sessionStorage.setItem('selectedRowsPerPage', rowsPerPage);
    sessionStorage.setItem('selectedPage', pageRange);

    navigate('/student-level-details', { state: studentId });
    // if (currentPath ==='/lte-session-student') {
    //   navigate('/lte-session-student/student-level-details', { state: studentId });
    // } 
    // else if (currentPath.startsWith('/lte-session/student')) {
    //   navigate('/lte-session/student/student-level-details', { state: studentId });
    // }
  };
  // * Table Columns Declarations
  const columns = [
    {
      name: "student_id",
      label: "Student Id",
      options: {
        filter: false,
        filterType: "Dropdown",
        sort: true,
        sortDirection: "desc",
        display: false,
        download: false,
        setCellProps: () => ({ align: "center" }),
      },
    },
    {
      name: "student_name",
      label: "Student Name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
        setCellProps: () => ({ align: "center" }),
      },
    },
    // {
    //   name: "group_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: true,
    //     download: true,
    //     setCellProps: () => ({align: "center"}),
    //     customBodyRender: (value) => {
    //       return value ? value : "-"
    //     }
    //   },
    // },
    // {
    //   name: "group_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: true,
    //     download: true,
    //     setCellProps: () => ({align: "center"}),
    //     customBodyRender: (value) => {
    //       return value ? value : "-"
    //     }
    //   },
    // },
    {
      name: "current_level_id",
      label: "Level Id",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: false,
        download: true,
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value) => {
          return value ? value : "-"
        }
      },
    },
    // {
    //   name: "level_name",
    //   label: "Current Level",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: false,
    //     download: true,
    //     setCellProps: () => ({align: "center"}),
    //     customBodyRender: (value) => {
    //       return (
    //         value ?
    //           <Chip
    //             label={value}
    //             color="primary"
    //             size="small"
    //             clickable
    //             onClick={() => setStudentModal(true)}
    //           />
    //          : "-"
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "session_name",
    //   label: "Current Session",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: false,
    //     download: true,
    //     setCellProps: () => ({align: "center"}),
    //     customBodyRender: (value) => {
    //       return value ? value : "-"
    //     }
    //   },
    // },
    // {
    //   name: "current_class_count",
    //   label: "Class Count",
    //   options: {
    //     filter: true,
    //     filterType: "Dropdown",
    //     sort: true,
    //     display: true,
    //     download: true,
    //     setCellProps: () => ({align: "center"}),
    //     customBodyRender: (value) => {
    //       return value !== null ? value : "-"
    //     }
    //   },
    // },

    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: true,
        filterType: "Dropdown",
        sort: true,
        display: true,
        download: true,
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value) => {
          return value ? value : "-"
        }
      },
    },
    {
      name: "Level Details",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, data) => {
          // console.log(data);
          let studentId = data.rowData[0]
          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <IconButton onClick={() => handleNavigation(studentId)}>
                <LibraryBooks color="primary" ></LibraryBooks>
              </IconButton>
            </div>

          );
        },
      },
    },
  ];

  // * Options for the Table Configuration
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "simple",
    elevation: 0,
    page: updatePageRange ? updatePageRange : pageRange,
    rowsPerPage: rowsPage ? rowsPage : rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    // onChangePage(currentPage) {
    //   console.log({ currentPage } );
    // },
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handleRowsPerPageChange,
    jumpToPage: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    onRowClick: (rowData) => {
      setSelectedRowData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }

  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  return (
    <Fragment>
      {/* Table */}
      <Box sx={{ p: "10px" }}>
        <MUIDataTable
          title="Students Sessions Data"
          data={studentsData}
          columns={columns}
          options={options}
          components={{ TableFilterList: CustomFilterList }}
        />
      </Box>

      {/* Modal */}
      <StudentDetails
        open={studentModal}
        onClose={() => setStudentModal(false)}
        selecteddata={selectedRowData}
      />
    </Fragment>
  );
}

export default StudentTraining;
